import {AUTH_TYPE, AuthViewParam} from '@Libraries/login-signup.types';
import type {SavedLoginAccount} from '@Libraries/login-signup-library';
import {COOKIE_EXPIRY_24_HOURS, readCookie, setCookie} from '@Utils/cookie.util';

const AUTH_VIEW_QUERY_PARAM = 'authView';
const REQUESTED_AUTH_VIEW_COOKIE = 'pmw_auth_view';

export const rememberRequestedAuthViewFromUrl = (): void => {
  if (window.PMW.isEmbedded()) {
    return;
  }
  const requestedView = new URLSearchParams(window.location.search).get(AUTH_VIEW_QUERY_PARAM);
  if (requestedView === AuthViewParam.SIGNUP) {
    setCookie(REQUESTED_AUTH_VIEW_COOKIE, requestedView, COOKIE_EXPIRY_24_HOURS);
  }
};

export const getRememberedAuthType = (): AUTH_TYPE | undefined => {
  return getAuthTypeForAuthViewParam(readCookie(REQUESTED_AUTH_VIEW_COOKIE));
};

export const getAuthTypeForAuthViewParam = (authView: string | null | undefined): AUTH_TYPE | undefined => {
  return authView === AuthViewParam.SIGNUP ? AUTH_TYPE.SIGNUP : undefined;
};

/** A device with saved logins opens on them, so a requested panel is dropped rather than hiding them. */
export const getRequestedAuthTypeUnlessSavedAccounts = (requestedAuthType: AUTH_TYPE | undefined, savedAccounts: SavedLoginAccount[]): AUTH_TYPE | undefined => {
  return savedAccounts.length > 0 ? undefined : requestedAuthType;
};
